import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-textarea"
    }}>{`sp-textarea`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a text area with optional associated label.`}</p>
    <p><img alt="Text areas" src={require("../../assets/sp-textarea.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/text-area/"
        }}>{`https://spectrum.adobe.com/page/text-area/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/textarea"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/textarea`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textarea placeholder="Enter your name">
    <sp-label slot="label">Name</sp-label>
</sp-textarea>
`}</code></pre>
    <h2 {...{
      "id": "variants-and-states"
    }}>{`Variants and states`}</h2>
    <p>{`There are several different variants for text areas.`}</p>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <p>{`Indicates that the text area is disabled.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textarea disabled placeholder="Enter your name"></sp-textarea>
`}</code></pre>
    <h3 {...{
      "id": "valid"
    }}>{`Valid`}</h3>
    <p>{`Indicates that the value of the text area is valid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textarea valid placeholder="Enter your name"></sp-textarea>
`}</code></pre>
    <h3 {...{
      "id": "invalid"
    }}>{`Invalid`}</h3>
    <p>{`Indicates that the value of the text area is invalid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textarea invalid placeholder="Enter your name"></sp-textarea>
`}</code></pre>
    <h3 {...{
      "id": "quiet"
    }}>{`Quiet`}</h3>
    <p>{`Styles the text area in a quieter, simpler appearance.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textarea quiet placeholder="Enter your name"></sp-textarea>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes on the text area using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` and `}<inlineCode parentName="p">{`input`}</inlineCode>{` events.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourTextArea").addEventListener("input", evt => {
    console.log(\`New value: \${evt.target.value}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      